import useChangeQueryParameter from 'utils/hooks/routes/useChangeQueryParameter'

import { categoryKey } from './useCategory'

export default function useChangeCategory() {
  const changeCategory = useChangeQueryParameter(categoryKey)

  return { changeCategory }
}
